import { useEffect, useState } from 'react';
import PermissionTree from './PermissionTree';

const EMPTY_FORM = {
  role: '',
  description: '',
};

export default function RoleEditModal({
  open,
  row,
  permissions,
  permissionsLoading,
  onClose,
  onSubmit,
  submitting,
}) {
  const isEdit = Boolean(row?.id);
  const isSuperAdmin = row?.id === 1;
  const [form, setForm] = useState(EMPTY_FORM);
  const [checkedLeafIds, setCheckedLeafIds] = useState(new Set());
  const [initialLeafIds, setInitialLeafIds] = useState(new Set());
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) {
      return;
    }
    const menuIds = Array.isArray(row?.menuIds) ? row.menuIds : [];
    const leafSet = new Set(menuIds);
    setForm({
      role: row?.role || '',
      description: row?.description || '',
    });
    setCheckedLeafIds(leafSet);
    setInitialLeafIds(new Set(menuIds));
    setError('');
  }, [open, row?.id, row?.role, row?.description, row?.menuIds]);

  if (!open) {
    return null;
  }

  function handleReset() {
    setForm({
      role: row?.role || '',
      description: row?.description || '',
    });
    setCheckedLeafIds(new Set(initialLeafIds));
    setError('');
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (!form.role?.trim()) {
      setError('請填寫角色名稱');
      return;
    }
    setError('');
    await onSubmit({
      id: row?.id,
      role: form.role.trim(),
      description: form.description?.trim() || '',
      menuIds: Array.from(checkedLeafIds),
    });
  }

  const title = isEdit ? `修改 [${row?.role || ''}]` : '新增角色';

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--role-edit"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>{title}</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-modal__body admin-modal__body--form">
            <div className="form-field">
              <label htmlFor="roleName">
                <span className="required-mark">*</span> 角色名稱：
              </label>
              <input
                id="roleName"
                type="text"
                value={form.role}
                disabled={isSuperAdmin}
                onChange={(e) => setForm((prev) => ({ ...prev, role: e.target.value }))}
                placeholder="請輸入角色名稱"
              />
            </div>

            {permissionsLoading ? (
              <p>載入權限樹…</p>
            ) : (
              <PermissionTree
                permissions={permissions}
                checkedLeafIds={checkedLeafIds}
                onChange={setCheckedLeafIds}
                disabled={isSuperAdmin}
              />
            )}

            {isSuperAdmin && (
              <p className="page-desc">超級管理員角色擁有全部權限，不可修改。</p>
            )}

            {error && <div className="alert alert-error">{error}</div>}
          </div>
          <div className="admin-modal__footer admin-modal__footer--center">
            <button type="submit" className="btn btn-primary" disabled={submitting || isSuperAdmin}>
              {submitting ? '提交中…' : '提交'}
            </button>
            <button type="button" className="btn btn-secondary" onClick={handleReset} disabled={submitting || isSuperAdmin}>
              重置
            </button>
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={submitting}>
              關閉
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
